import React from 'react';
import { BrainIcon, BanknoteIcon, PenLineIcon, CalendarIcon, CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { iaTools } from '../constants/data';
const includes = [{
  icon: BrainIcon,
  text: 'Mentalidad para el mundo que ya cambió'
}, {
  icon: BanknoteIcon,
  text: 'Cómo generar ingresos con IA'
}, {
  icon: PenLineIcon,
  text: 'Prompts y plantillas listas para usar'
}, {
  icon: CalendarIcon,
  text: 'Plan de acción de 30 días'
}];
export function EbookIA() {
  return <section className="relative w-full overflow-hidden px-5 py-16 sm:py-24" style={{
    background: 'linear-gradient(180deg, #0A0A0A 0%, #050B18 100%)'
  }} data-id="element-82">
      <div className="absolute inset-0 grid-pattern opacity-40" aria-hidden="true" data-id="element-83" />
      <div className="relative mx-auto max-w-4xl text-center" data-id="element-84">
        <Reveal data-id="element-85">
          <span className="inline-block glass px-4 py-2 text-xs sm:text-sm font-semibold" style={{
          color: '#00C853'
        }} data-id="element-86">
            🤖 INCLUIDO EN EL MEGAPACK
          </span>

          <h2 className="mt-6 text-3xl sm:text-4xl font-extrabold" data-id="element-87">
            EL MULTIPLICADOR{' '}
            <span style={{
            color: '#00C853'
          }} data-id="element-88">
              IA
            </span>
          </h2>
          <p className="mt-2 text-lg sm:text-xl font-semibold text-white/80" data-id="element-89">
            Mentalidad y Herramientas para el Mundo que ya Cambió
          </p>

          <p className="mt-5 max-w-2xl mx-auto text-base text-white/70" data-id="element-90">
            La inteligencia artificial ya cambió las reglas del juego. Te
            enseñamos a usarla gratis para ganar más, trabajar menos y crear
            ingresos que antes parecían imposibles.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-91">
          <div className="mt-10 glass overflow-hidden text-left" data-id="element-92">
            <div className="overflow-x-auto no-scrollbar" data-id="element-93">
              <table className="w-full min-w-[480px] text-sm" data-id="element-94">
                <thead data-id="element-95">
                  <tr className="border-b" style={{
                  borderColor: 'rgba(0,200,83,0.3)'
                }} data-id="element-96">
                    <th className="px-4 py-3 text-left font-semibold text-white" data-id="element-97">
                      Herramienta
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-white" data-id="element-98">
                      Para Qué
                    </th>
                    <th className="px-4 py-3 text-center font-semibold" style={{
                    color: '#00C853'
                  }} data-id="element-99">
                      Gratis
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-100">
                  {iaTools.map((row, i) => <tr key={row.tool} style={{
                  backgroundColor: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.02)'
                }} data-id="element-101">
                      <td className="px-4 py-3 font-medium text-white" data-id="element-102">
                        {row.tool}
                      </td>
                      <td className="px-4 py-3 text-white/70" data-id="element-103">{row.use}</td>
                      <td className="px-4 py-3 text-center" data-id="element-104">
                        <CheckIcon className="inline w-4 h-4" style={{
                      color: '#00C853'
                    }} strokeWidth={3} aria-label="Gratis" data-id="element-105" />
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </Reveal>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 text-left" data-id="element-106">
          {includes.map(({
          icon: Icon,
          text
        }, i) => <Reveal key={text} delay={i * 0.08} data-id="element-107">
              <div className="flex items-center gap-3 glass p-4" data-id="element-108">
                <Icon className="w-5 h-5 shrink-0" style={{
              color: '#00C853'
            }} aria-hidden="true" data-id="element-109" />
                <span className="text-sm text-white/80" data-id="element-110">{text}</span>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.15} data-id="element-111">
          <div className="mt-8 flex items-center justify-center gap-4 flex-wrap" data-id="element-112">
            <span className="text-lg line-through" style={{
            color: '#FF3B30'
          }} data-id="element-113">
              $15.000 ARS
            </span>
            <span className="text-sm font-bold px-4 py-2 rounded-full" style={{
            backgroundColor: 'rgba(0,200,83,0.15)',
            color: '#00C853'
          }} data-id="element-114">
              ✅ INCLUIDO EN EL MEGAPACK
            </span>
          </div>
        </Reveal>
      </div>
    </section>;
}